import "./components/header-height";
import "./components/accordion";
import "./components/slider";
import "./components/link-img-list";
import "./components/testimonials";
import "./components/lottie";
import "./components/about-slider";
import "./components/quality-slider";
import "./components/morph-graph";
import "./components/multi-circle-slider";
// import "./components/scrolling";
//import "./components/pill-tab";
import "./components/capabilities";
import "./components/team-slider";
import "./components/overflow-slider";
import "./components/all-services-slider";
import "./components/gradient-slider";
import "./components/vertical-tabs"; //
import "./components/facilities-accordion";
import "./components/facilities-map";
import "./components/history-slider";
import "./components/team-listing";
import "./components/explore-services-slider";
import "./components/gmp-slider";
import "./components/early-late-slider";
import "./components/wave-slider";
import "./components/global-facilities";
import "./components/circle-wave-slider";
import "./components/quality-steps";
import "./components/pill-tabs";
import "./components/big-wave-slider";
import "./components/single-circle-slider";
import "./components/therapeutic-grid";
import "./components/knowledge-center-slider";
import "./components/tab-slider";
import "./components/tab-tech";
import "./components/lot-release-assay-table";
import { gsap } from "gsap";
import { observeAndAnimate, horizontalLoop } from "./components/utils";

const hpHeroEls = document.querySelectorAll( "svg #heromask g" );
if ( hpHeroEls.length > 0 ) {
  const heroTl = gsap.timeline( {
    defaults: {
      repeat: -1,
      yoyo: true,
      duration: 5,
      ease: "power2.inOut",
    },
  } );
  hpHeroEls.forEach( ( el, i ) => {
    if ( i > 0 ) {
      let randomY = Math.random() * 150 - 75;
      heroTl.to( el, { y: randomY }, "<" );
    }
  } );
}
// console.log("els.length == ", els.length);

const matEls = document.querySelectorAll( "svg#mat-hero-graphic g" );
if ( matEls.length > 0 ) {
  const matTl = gsap.timeline( {
    defaults: {
      repeat: -1,
      yoyo: true,
      duration: 3.5,
      ease: "power2.inOut",
    },
  } );
  matEls.forEach( ( el, i ) => {
    if ( i > 0 ) {
      let randomY = Math.random() * 100 - 50;
      matTl.to( el, { y: randomY }, "<" );
    }
  } );
}
// const exploreAccents = document.querySelectorAll(".explore-accent ellipse");
// exploreAccents.forEach((el, i) => {
//   let randomY = Math.random() * 2 - 4;
//   heroTl.to(el, {
//     y: randomY,
//     duration: 1,
//     ease: "power2.inOut",
//   },"+=");
// });

// const heroContainer = document.querySelector("#hp-hero .container");
// if (heroContainer && 1 > 2) {
//   // image effect
//   heroContainer.addEventListener("mousemove", function (event) {
//     const { left, top, width, height } = heroContainer.getBoundingClientRect();
//     const centerX = left + width / 2;
//     const centerY = top + height / 2;
//     const dx = event.clientX - centerX;
//     const dy = event.clientY - centerY;
//     const angle = Math.atan2(dy, dx);
//     const distance = Math.sqrt(dx * dx + dy * dy);
//     const maxDistance = Math.sqrt(
//       (width / 2) * (width / 2) + (height / 2) * (height / 2)
//     );

//     const translateX = Math.cos(angle) * distance;
//     const translateY = Math.sin(angle) * distance;

//     const maxTranslate = maxDistance / 2;

//     const img = heroContainer.querySelector(".lady");
//     // const imgGsap = gsap.utils.selector(".box.active .img-wrapper img");
//     if (img) {
//       const multiplier = -0.0125;
//       img.style.transform = `translate(${translateX * multiplier}px, ${
//         translateY * multiplier
//       }px)`;
//     }
//   });
// }
// Generic Animation functions
function slideIn ( element ) {
  gsap.to( element, { translateX: 0 } );
}
function slideUp ( element ) {
  gsap.to( element, { translateY: 0 } );
}

// Observing and animating specific elements
observeAndAnimate( "g.hero-chevron-purple", slideIn );
observeAndAnimate( "g.cta-chevrons", slideIn );
